/**
 * UND Core JS
 * -----------------------------------------------------------------------------
 */

// Imports



// Polyfills



// Run Early
require( './utilities/_fetch-svg' );
require( 'what-input' );
require( './vendor/modernizr/_modernizr' );
// YouTube embeded videos.
// TODO: verify if this should run early and if it needs to be imported by `_leaders-in-action.js`.
require( './utilities/_embed' )(); // DEPRECATED, replaced by `lite-youtube-embed`
require( 'lite-youtube-embed' );
require( './vendor-extensions/lite-vimeo-embed/lite-vimeo-embed' );
require( './utilities/_events' );
require( './partials/_campus-alert' );
require( './partials/_header-offset' );
require( './partials/_cookie-banner' );
require( './utilities/_anchor' );
require( './partials/_subnav' );
require( './partials/_topbar' );



// Vendor



// Vendor Extensions



// Partials
require( './partials/_article-meta' );
require( './partials/_back-to-top' );
require( './partials/_breadcrumb' );
require( './partials/_condensed' );
require( './partials/_direct-edit' );
require( './partials/_form' );
require( './partials/_header' );
require( './partials/_hero' );
require( './partials/_menu' );
require( './partials/_quick-escape' );
require( './partials/_print-pdf' );



// Components
require( './components/_count-up' );
require( './components/_dropdown' );
require( './components/_event' );        // ¿Abandoned?
require( './components/_minimodal' );
require( './components/_stats-slider' );

require( './components/t-featured-slider' );
require( './components/u-accordion-group-trigger' );
require( './components/u-accordion' );
require( './components/u-story-feed' );
require( './components/u-tabs' );
require( './components/u-tuition-table' );



// Pages
require( './pages/home/_lia-slider' );
require( './pages/home/_majors-and-programs-slider' );
require( './pages/home/_program-search' );
require( './pages/home/tint-feed' );
require( './pages/_leaders-in-action' );
require( './pages/tuition-calculator' );




/**
 * Export Plugins, Utilities, and Constants
 *
 * - These will be available within the `UND` global variable.
 * - Exported for use within third-party code.
 */
module.exports = {
  Constants: require( './utilities/_constants' ),
  Utilities: {
    animateTo:        require( './utilities/_animate-to' ),
    copyToClipboard:  require( './utilities/_copy-to-clipboard' ),
    debounce:         require( './utilities/_debounce' ),
    MediaQuery:       require( './utilities/_media-query' ).MediaQuery,
    throttle:         require( './vendor/throttle/_throttle' )
  },
  Plugins: {
    minimodal: require( './vendor/minimodal/_minimodal' ),
    Snackbar:  require( './components/snackbar' )
  }
};
